import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M250 497.646C113.441 497.646 2.354 386.559 2.354 250S113.441 2.354 250 2.354 497.646 113.441 497.646 250 386.559 497.646 250 497.646m0-459.914C132.896 37.732 37.732 132.896 37.732 250S132.896 462.268 250 462.268 462.268 367.104 462.268 250 367.104 37.732 250 37.732m-21.934 347.587L334.2 261.496c5.66-6.543 5.66-16.449 0-22.992L228.066 114.681c-6.368-7.432-17.514-8.316-24.94-1.947-7.433 6.368-8.316 17.513-1.948 24.94L297.407 250l-96.229 112.327c-6.368 7.432-5.485 18.577 1.948 24.945 3.362 2.83 7.426 4.246 11.496 4.246 4.953 0 9.906-2.123 13.444-6.193z" }, null, -1)
  ])))
}
export default { render: render }